import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './services/axiosConfig';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import initSentry from './utils/sentry';

// Ensure cookie-based auth works across the app (especially in Vercel preview)
axios.defaults.withCredentials = true;

// Initialize Sentry as early as possible
initSentry();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
